export const authorConfig = {
  BaseUrl: "/author",
  LoginRedirect: "/app",
  TokenKey: "author-token",
  DeliveryTokenKey: "delivery-token",
  DocsSiteUrl: "https://cirrus.zendesk.com/hc/en-us",
}
